import { useBoundStore } from '@/shared/store';
import { useShallow } from 'zustand/shallow';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from '@/shared/ui/shadcn/ui/breadcrumb';
import { Link } from 'react-router';
import { BreadcrumbPage } from '@/shared/ui/shadcn/ui/breadcrumb';
import { cn } from '@/shared/lib/shadcn/utils';
import { useTranslation } from 'react-i18next';
import React from 'react';

export function PageBreadcrumbs() {
  const { pageBreadcrumbs } = useBoundStore(
    useShallow((state) => ({
      pageBreadcrumbs: state.pageBreadcrumbs,
    })),
  );
  const { t } = useTranslation();

  return (
    <Breadcrumb className="max-w-[calc(100%-500px)] flex-shrink-0">
      <BreadcrumbList>
        {pageBreadcrumbs?.map((breadcrumb, index) => {
          const isLastItem = index === pageBreadcrumbs.length - 1;
          return (
            <React.Fragment key={breadcrumb.title}>
              <BreadcrumbItem key={breadcrumb.title} isLastItem={isLastItem}>
                {isLastItem ? (
                  <BreadcrumbPage
                    className={cn(
                      'max-w-[300px] truncate text-[20px] font-semibold',
                      {
                        'text-grey-6c737f': pageBreadcrumbs.length > 1,
                      },
                    )}
                  >
                    {t(breadcrumb?.title)}
                  </BreadcrumbPage>
                ) : (
                  <BreadcrumbLink asChild>
                    <Link
                      className="text-foreground text-24 font-semibold whitespace-nowrap"
                      to={breadcrumb?.href}
                    >
                      {t(breadcrumb?.title)}
                    </Link>
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
              {index < pageBreadcrumbs.length - 1 && <BreadcrumbSeparator />}
            </React.Fragment>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
